<template >

<div v-if="flag==true">
<div class="modal fade stats-modal show" id="socrecard1"  @click.self="close_batsman_popup" aria-hidden="true" style="display: block;">

                <div class="modal-dialog modal-dialog-centered" >
                    <div class="modal-content">
                        <a href="javascript:;" class="close" @click="close_batsman_popup" data-dismiss="modal" aria-label="Close"><span></span></a>

                        <div class="player-info-head">

                            <div class="player-info-head-lft">
                                <div class="plyer-img">
                                 <router-link :to="{ name: 'playerDetail.info', params:  { player: batsman.slug} }">
                                   <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+batsman.id+'.png').resizeImage(90)" @error="$event.target.src='/public/images/User_Male.jpg'" alt="">
                                   </router-link>
                                </div>
                                <div class="plyer-desc">
                                     <router-link :to="{ name: 'playerDetail.info', params:  { player: batsman.slug} }">
                                       <strong class="name">{{batsman.name}}</strong>
                                      </router-link>
                                   <router-link :to="{ name: 'playerDetail.info', params:  { player: batsman.slug} }">
                                    <span class="view-profile" @click="close_batsman_popup">View Profile</span>
                                </router-link>
                                </div>
                            </div>
                            <div class="player-info-head-rgt">
                                <ul class="info-ul">
                                <li>
                                        <span class="title-li">R</span>
                                        <span class="sub-title-li">{{batsman_status.score}}</span>
                                    </li>
                                    <li>
                                        <span class="title-li">B</span>
                                        <span class="sub-title-li">{{batsman_status.balls}}</span>
                                    </li>
                                     <li>
                                        <span class="title-li">4S</span>
                                        <span class="sub-title-li">{{batsman_status.four}}</span>
                                    </li>
                                     <li>
                                        <span class="title-li">6S</span>
                                        <span class="sub-title-li">{{batsman_status.six}}</span>
                                    </li>
                                     <li>
                                        <span class="title-li">SR</span>
                                        <span class="sub-title-li">{{batsman_status.runrate}}</span>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <div class="table-responsive">
                            <div class="match-table">
                                <div class="thead">
                                    <div class="table-row">
                                        <div class="th">To Bowler</div>
                                        <div class="th">R</div>
                                        <div class="th">B</div>
                                        <div class="th">4S</div>
                                        <div class="th">6S</div>
                                        <div class="th">SR</div>
                                    </div>
                                </div>
                                <div class="table-body">
                                    <div class="tbody">
                                        <div class="table-row "  v-for="(bowler,index) in against_bowlers" :key="bowler.id">
                                            <div class="td">
                                            <span class="title d-none d-md-block" id="newId"><input v-if="shot_direction!=''" type="checkbox" :value="bowler['bowler_id']" :id="bowler['bowler_id']" v-model="selectplayers" @change="checkplayer()" class="ml-8"> {{index}}
                                                <router-link class="eye-icon" :to="{ name: 'playerDetail.info', params:  { player: bowler['slug']} }"><img :src="('/public/images/View_icon_1.svg')" alt=""></router-link>
                                            </span>
                                            <span class="title d-md-none"><input v-if="shot_direction!=''" type="checkbox" :value="bowler['bowler_id']" :id="bowler['bowler_id']" v-model="selectplayers" @change="checkplayer()" class="ml-8"> {{bowler['short_name']}}
                                                <router-link class="eye-icon" :to="{ name: 'playerDetail.info', params:  { player: bowler['slug']} }"><img :src="('/public/images/View_icon_1.svg')" alt=""></router-link>
                                            </span>
                                            </div>
                                            <div class="td">{{bowler['score']}}</div>
                                            <div class="td">{{bowler['balls']}}</div>
                                            <div class="td">{{bowler['fours']}}</div>
                                            <div class="td">{{bowler['sixes']}}</div>
                                            <div class="td">{{Math.floor((bowler['score']/bowler['balls'])*100)}}</div>
                                        </div>
                                    </div>
                                <div class="">
                                    <wagon v-if="batsman.id && show_selected_wagonwheel" :shots='shot_direction' :type='"batsman"' :key="batsman.id"></wagon>
                                    <wagon v-if="batsman.id &&  show_complete_wagonwheel" :shots='selected_shot_directions' :type='"batsman"' :key="batsman.id"></wagon>
                                     <ul class="ground-scroe-info" >
                                            <li v-if="shot_direction!=''"><label><input type="checkbox" v-model="boundaries" :value="1" :id="1" @change="checkplayer()"><span>1 Runs</span></label></li>
                                            <li v-if="shot_direction!=''"><label><input type="checkbox" v-model="boundaries" :value="2" :id="2" @change="checkplayer()"><span>2 Runs</span></label></li>
                                            <li v-if="shot_direction!=''"><label><input type="checkbox" v-model="boundaries" :value="3" :id="3" @change="checkplayer()"><span>3 Runs</span></label></li>
                                            <li v-if="shot_direction!=''"><label><input type="checkbox" v-model="boundaries" :value="4" :id="4" @change="checkplayer()"><span>4 Runs</span></label></li>
                                            <li v-if="shot_direction!=''"><label><input type="checkbox" v-model="boundaries" :value="6" :id="6" @change="checkplayer()"><span>6 Runs</span></label></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</div>

</template>
<script>
import axios from 'axios';
import wagon from './wagon.vue'
export default {
        name: 'BatsmanMiniStats',
        components: {wagon},
        props:['batsman_slug','match_slug','inning_order'],
        data(){
            return {
            selected_shot_directions:[],
            selectplayers:[],
            boundaries:[],
            flag:false,
            show_selected_wagonwheel:true,
            show_complete_wagonwheel: false,
            batsman:'',
            against_bowlers:[],
            shot_direction:'',
            batsman_status:'',
            }
        },
        created()
        {
            var url = this.$BATSMAN_DETAIL.replace(':player_slug', this.batsman_slug);
            url = url.replace(':match_slug', this.match_slug);
            url = url.replace(':inning', this.inning_order);
            this.$axios.get(url)
                .then(response => {
                    if(response.data.result != ''){
                        this.batsman = response.data.result.info;
                        this.against_bowlers = response.data.result.bowlers;
                        this.shot_direction=response.data.result.shot_direction;
                        this.batsman_status = response.data.result.status[0];
                    }
                    this.flag=true;
                });
        },
        mounted()
        {
           this.flag=false;
        },
        methods:
         {
             checkplayer()
            {
               var checkname=this.selectplayers;
               var boundaries=this.boundaries;
               if(checkname.length!=0)
               {
                    this.selected_shot_directions=[];
                    this.show_complete_wagonwheel = false;
                    this.show_selected_wagonwheel=false;
                    if(boundaries.length!=0)
                    {
                        var length=checkname.length;
                        var boundarylength=boundaries.length;
                        var j=0;
                        for(var i=0;i<length;i++)
                        {
                            for(var b=0;b<boundarylength;b++)
                            {
                                this.shot_direction.forEach(shot => {
                                if(shot.bowler_id==this.selectplayers[i] && shot.score==boundaries[b])
                                {
                                    this.selected_shot_directions[j++]=shot;
                                }
                                });
                            }
                        }
                        this.$nextTick(() => {
                        this.show_complete_wagonwheel = true;
                        });
                    }
                    else
                    {
                        var length=checkname.length;
                        var j=0;
                        for(var i=0;i<length;i++)
                        {
                            this.shot_direction.forEach(shot => {
                            if(shot.bowler_id==this.selectplayers[i])
                            {
                                this.selected_shot_directions[j++]=shot;
                            }
                            });
                        }
                        this.$nextTick(() => {
                        this.show_complete_wagonwheel = true;
                        });
                    }
               }
               else if(boundaries.length!=0)
               {
                    this.selected_shot_directions=[];
                    this.show_complete_wagonwheel = false;
                    this.show_selected_wagonwheel=false;
                    if(checkname.length!=0)
                    {
                        var length=checkname.length;
                        var boundarylength=boundaries.length;
                        var j=0;
                        for(var i=0;i<length;i++)
                        {
                            for(var b=0;b<boundarylength;b++)
                            {
                                this.shot_direction.forEach(shot => {
                                if(shot.bowler_id==this.selectplayers[i] && shot.score==boundaries[b])
                                {
                                    this.selected_shot_directions[j++]=shot;
                                }
                                });
                            }
                        }
                        this.$nextTick(() => {
                        this.show_complete_wagonwheel = true;
                        });
                    }
                    else
                    {
                        var length=boundaries.length;
                        var j=0;
                        for(var i=0;i<length;i++)
                        {
                            this.shot_direction.forEach(shot => {
                            if(shot.score==boundaries[i])
                            {
                                this.selected_shot_directions[j++]=shot;
                            }
                            });
                        }
                        this.$nextTick(() => {
                        this.show_complete_wagonwheel = true;
                        });
                    }
               }
               else
               {
                    this.show_complete_wagonwheel = false;
                    this.$nextTick(() => {
                    this.show_selected_wagonwheel=true;
                    });
                }
            },
              close_batsman_popup()
             {
                this.flag=false;
                // this.$router.replace({'query': null}).catch(()=>{});
                this.$emit('ShowBatsmanPopup');

            },
        }
}
</script>
<style lang="scss">
.ground-scroe-info{
    margin: 0 -8px;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.ground-scroe-info li{
    padding: 2px 8px;
}
.ground-scroe-info input[type="checkbox"]{
    opacity: 0;
}
.ground-scroe-info span{
    position: relative;
    padding-left: 20px;
    cursor: pointer;
}
.ground-scroe-info span::before{
    position: absolute;
    content: "";
    width: 14px;
    height: 14px;
    overflow: hidden;
    border-radius: 50%;
    top:2px;
    left: 0;
    background: #1c73dc;
}
.ground-scroe-info span::after{
    position: absolute;
    left: 3px;
    top: 5px;
    width: 8px;
    height: 5px;
    content: "";
    border: solid #fff;
    border-width: 0 0 2px 2px;
    transform: rotate(-45deg);
    opacity: 0;
}
.ground-scroe-info input[type="checkbox"]:checked + span::after{
    opacity: 1;
}
.ground-scroe-info li:nth-child(2) span::before{
    background: #50f3bc;
}
.ground-scroe-info li:nth-child(3) span::before{
    background: #ffdd00;
}
.ground-scroe-info li:nth-child(4) span::before{
    background: #b144ff;
}
.ground-scroe-info li:nth-child(5) span::before{
    background: #ed2225;
}
@media (min-width: 576px){
.stats-modal .match-table .td:nth-child(2),
.stats-modal .match-table .td:nth-child(3),
.stats-modal .match-table .td:nth-child(4),
.stats-modal .match-table .td:nth-child(5),
.stats-modal .match-table .td:nth-child(7),
.stats-modal .match-table .th:nth-child(2),
.stats-modal .match-table .th:nth-child(3),
.stats-modal .match-table .th:nth-child(4),
.stats-modal .match-table .th:nth-child(5),
.stats-modal .match-table .th:nth-child(7) {
    width: 38px;
}
}

.eye-icon img{
width: 16px;
margin-top:3px;
}
.match-table .table-row.active-basement .title .bat {
    color: #b7b6b5;
    display: inline;
    font-size:13px;
}
.match-table .table-row .title .bat {
    color: #b7b6b5;
    display: inline;
    font-size:13px;
}
</style>
